import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { ApartmentService } from 'src/app/_services/apartments/apartment.service';

@Component({
  selector: 'app-Reports',
  templateUrl: './Reports.component.html',
  styleUrls: ['./Reports.component.css']
})
export class ReportsComponent implements OnInit {
  showSide: string;
  rpt_end_date:any
  rpt_start_date:any
  selected_type: string = '';
  subscriptions:Subscription[] = [];

  rpt_type:any = [
    {name:'Free Beds' },
    {name:'Checkouts' },
    {name:'Upcoming' },
    {name:'Partner Commissions' },
    {name:'Extensions' },
    {name:'Issues' },


  ];

  constructor(private _apartmnetService:ApartmentService,private messageService: MessageService,) { }

  ngOnInit() {
  }
  addItem(value: string): void {
    this.showSide = value;
  }
  formatDateLocal(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth is 0-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }
GenerateButton(){
let Start_Date=this.formatDateLocal(this.rpt_start_date);
let End_Date=this.formatDateLocal(this.rpt_end_date);

  console.log(this.formatDateLocal(this.rpt_start_date));
  console.log(this.formatDateLocal(this.rpt_end_date));
  console.log(this.selected_type);
  this.GetFreeBed_Rpt(Start_Date,End_Date,this.selected_type);
}
GetFreeBed_Rpt(start_date:any,end_date:any,rpt_type:any) {
  this.subscriptions.push(this._apartmnetService.GetReport(start_date,end_date,this.selected_type).subscribe(
    (res:Blob) => {
      const blob = new Blob([res], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = 'FreeBeds.xlsx';
      link.click();

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Report has been generated and downloaded',
      });
    },
    (error) => {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: `${error.error['message']}`,
      });
    }
  ))

}
}
